export const validarEntrada = (
    mensaje,
    validador,
    errorMensaje,
    siguienteEtapa,
    key,
    setVentaState,
    ventaState,
    setState,
    createChatBotMessage,
) => {
    if (!validador(mensaje)) {
        const mensajeError = createChatBotMessage(errorMensaje);
        setState((prevState) => ({
            ...prevState,
            messages: [...prevState.messages, mensajeError],
        }));
        return false;
    }

    setVentaState({
        etapa: siguienteEtapa,
        datos: { ...ventaState.datos, [key]: mensaje },
    });
    return true;
};

// Funciones de validación
export const validarNombre = (nombre) => nombre.trim().split(" ").length >= 2;
export const validarDomicilio = (domicilio) => domicilio.trim().length >= 10;
export const validarTelefono = (telefono) => /^[0-9]{10}$/.test(telefono);
export const validarEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const validarCURP = (curp) => {
    const regex = /^[A-Z0-9]{18}$/;
    return regex.test(curp);
  };